import { Injectable } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from 'src/app/core/constants/url.constants';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { SubmitQuoteModel } from '../../../core/model/submit-quote-model';
import { QuoteEditModel } from '../../../core/model/quote-edit-model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { HttpHeaders } from '@angular/common/http';
import { QuoteTabNameModel } from '../../../core/model/quote-tab-name-model';
import moment from 'moment';
import { WindowRef } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export default class InventoryManagementService {
  inventoryData: any;
  userid;
  quotesData: any;
  query = '';
  queryForQuote = '';
  filterValue: any = null;
  products: any;
  quoteTabNameModel = new QuoteTabNameModel();
  productData$: Observable<any>;
  contactData: any;
  addData: any;
  bidPlaced = false;
  isRedirectFromQuotesDetails = false;
  quoteStatusName = null;
  private notificationChnageSub = new BehaviorSubject(null);
  notificationChnageSub$ = this.notificationChnageSub.asObservable();
  private filterSortSearchSubject = new BehaviorSubject(null);
  filterSortSearchSubject$ = this.filterSortSearchSubject.asObservable();
  private refreshCarouselComp = new BehaviorSubject(null);
  private refreshCarouselCompProduct = new BehaviorSubject(null);
  private refreshCarouselCompAll = new BehaviorSubject(null);
  private logout = new BehaviorSubject(null);
  logout$ = this.logout.asObservable();
  lang = 'en';
  refreshComp$ = this.refreshCarouselComp.asObservable();
  refreshCompProduct$ = this.refreshCarouselCompProduct.asObservable();
  refreshCompAll$ = this.refreshCarouselCompAll.asObservable();
  private userName = new BehaviorSubject(null);
  userName$ = this.userName.asObservable();
  userGroup: any;
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();

  private sortChange = new BehaviorSubject('relevance');
  sortChange$ = this.sortChange.asObservable();

  private searchInput = new BehaviorSubject(null);
  searchInput$ = this.searchInput.asObservable();

  private filterInput = new BehaviorSubject(null);
  filterInput$ = this.filterInput.asObservable();

  private statusBarInput = new BehaviorSubject(null);
  statusBarInput$ = this.statusBarInput.asObservable();

  private homeLinkActive = new BehaviorSubject(true);
  homeLinkActive$: any;

  private privacyPolicyData = new BehaviorSubject(null);
  privacyPolicyData$ = this.privacyPolicyData.asObservable();
  date: any;
  hour: any;
  min: any;
  expiring: string;

  getShipmentStatusInfo(value): any {
    this.statusBarInput.next(value);
  }

  getNotificationValue(value): any {
    this.notificationChnageSub.next(value);
  }
  getLogout(value): any {
    this.logout.next(value);
  }
  refreshFunction(value): any {
    this.refreshCarouselComp.next(value);
  }
  refreshFunctionProduct(value): any {
    this.refreshCarouselCompProduct.next(value);
  }
  refreshFunctionAll(value): any {
    this.refreshCarouselCompAll.next(value);
  }
  getUserDetails(value): any {
    this.userName.next(value);
  }

  getLanguageChange(value): any {
    this.languageChange.next(value);
  }

  getSearchInput(value): any {
    this.searchInput.next(value);
  }

  getFilterInput(value): any {
    this.filterInput.next(value);
  }

  getsortChange(value): any {
    this.sortChange.next(value);
  }

  getFilterSortSearchInput(value): any {
    this.filterSortSearchSubject.next(value);
  }

  setPrivacyPolicyData(value):any{
    this.privacyPolicyData.next(value);
  }
  getPrivacyPolicyData(){
    return this.privacyPolicyData$;
  }
  constructor(private httpUtilService: HttpUtilService,
              private translation: TranslationService,
              private userAccountFacade: UserAccountFacade,
              private winRef: WindowRef,
              private httpClient:HttpClient
  ) {
    this.translation.translate('home.myAccount.language').subscribe(res => {
      this.lang = res;
      this.getLanguageChange(res);
    });
   }
    getInventoryData(currentPage?:any, sortData?:any, searchValue?:any,query?:any){
      let url = '';
      if(searchValue?.length >= 3){
        url = Constants.inventoryManagement(currentPage,sortData,searchValue).INVENTORY_MANAGEMENT_SEARCH;
      }else if(query!=null){
        url = Constants.inventoryManagement(currentPage,sortData,searchValue,query).INVENTORY_FILTER_RESULT;
      }
      else {
        url = Constants.inventoryManagement(currentPage,sortData,searchValue).INVENTORY_MANAGEMENT;
      }
        return this.httpUtilService.get(url).pipe(map((response: any) => response))
        //    return this.httpClient.get("/assets/inventory-management.json").pipe(map((response: any) => response));
    }
    getInventoryDetails(id: string,quotesSort? : any){
      return this.httpUtilService.get(Constants.inventoryData(id,quotesSort).INVENTORY_DETAILS).pipe(map((response: any) => response))
         //return this.httpClient.get("/assets/inventory-details.json").pipe(map((response: any) => response));
    }
    unpublishBatch(productCode?: any, toggle?: any){
      return this.httpUtilService.post(Constants.inventoryPublishUnpublishBatch(productCode,toggle).INVENTORY_UNPUBLISH_BATCH,{});
    }
    publishBatch(productCode?: any, toggle?: any , price? : any){
      return this.httpUtilService.post(Constants.inventoryPublishUnpublishBatch(productCode,toggle,price).INVENTORY_PUBLISH_BATCH,{})
    }
    getRecordPickupDetails(batchId: any, contractNumber: any){
      return this.httpUtilService.get(Constants.inventoryRecordPickup(batchId, contractNumber).INVENTORY_PICKUP).pipe(map((response: any)=>response))
    }
    saveRecordPickupDetails(data: any){
      return this.httpUtilService.post(Constants.inventoryRecordPickup().INVENTORY_PICKUP_SAVE,data).pipe(map((response: any)=>response))
    }
    updatePrice(productCode: any, price: any){
      return this.httpUtilService.post(Constants.inventoryUpdatePrice(productCode,price).INVENTORY_UPDATE_PRICE,{})
    }
    getHelpData(): Observable<any> {
      //return this.httpClient.get("/assets/privacypolicy.json").pipe(map((response: any)=>response))
      return this.httpUtilService.get(Constants.getPrivacyPolicy(this.lang).PRIVAY_POLICY).pipe(map((response: any)=>response))
    }
    getFaqData(data: any){
      return this.httpUtilService.get(Constants.getFaqDownloadLink(data).DOWNLOAD_FAQ).pipe(map((response: any)=>response))
    }
}
